import config from '@/config/index.js';

// 省份
const provincesList = {
    url: `/uds/ss/fellow/v1/provinces`,
    method: 'get',
    dataType: 'array'
};
// 城市
const citiesList = {
    url: `/uds/ss/fellow/v2/provinces/{province_id}/cities`,
    method: 'get',
    dataType: 'array'
};
// 全量城市列表
const cityAll = {
    url: `/beyonder/api/v1/geo/region/grade`,
    method: 'get',
    dataType: 'array',
    mergeData: {
        wx_app_id: config.wx_app_id,
        grade: 2
    }
};
// 热门城市
const hotCitiesList = {
    url: `/uds/in/fellow/v1/hot-cities`,
    // url: `/uds/ss/fellow/v1/nio-houses-cities`,
    method: 'get'
};
// http://showdoc.nevint.com/index.php?s=/urm&page_id=10076
// 根据经纬度逆解析地址
const inverseSearch = {
    url: `/uds/ss/sales/v1/pois/inverse_search`,
    method: 'get'
};

export default {
    provincesList,
    citiesList,
    cityAll,
    inverseSearch,
    hotCitiesList
};



// WEBPACK FOOTER //
// ./src/service/common/area.js